import styles from "../../styles/components/footer.module.scss";
import _get from "lodash/get";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

function Footer(props) {
  const router=useRouter();
  const [isExcluded, setisExcluded] = useState(false)
const contactUsHidePath=['/product','/product_details','/product_details_chatbot','/product_details_cupa','/product_details_sap','/product_details_suite']
//  const contactUsHidePath=['/product','/product_details','/product_details_chatbot','/product_details_cupa','/product_details_sap','/product_details_suite']
  //console.log("footer props",router.asPath,router.asPath=="/login")
  useEffect(()=>{
    if(contactUsHidePath.includes(router.asPath?.split("?")[0])){
      setisExcluded(true)
    }
  },[router])
  return (

    <footer className={`${styles.footer} ${props.title == "Demand" ? `${styles.modFooter}` : null} `}>
      <div className={`${styles.footWrapper} container`}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className={`${styles.left} pr-lg-5`} dangerouslySetInnerHTML={{ __html: props.footerProps.field_footer_text }}></div>
          </div>
          <div className="col-12 col-md-6">
            <div className={styles.right}>
              <p>{_get(props, "footerProps.field_contact_us", "")}</p>
              <ul>
                {_get(props, "footerProps.field_email_id", []).filter((v)=>isExcluded?v!=="ML_IND_ETSC_RPA_Support@unilever.com":v).map((item, index) => (
                  <li style={index==0?{borderRight: isExcluded?"none":"2px solid"} : undefined} key={index}><a href={`mailto:${item}`}>{item}</a></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;

